require('./bootstrap');
import 'bootstrap';
var $ = require('jquery');


// Index calendario
// Colora la casella del sabato e della domenica di rosso
$( ".settimana:contains('dom')" ).css( "background", "rgb(255, 114, 114)" );
$( ".settimana:contains('sab')" ).css( "background", "rgb(255, 114, 114)" );

$('.table').on('click','.aggiungi', function(){
    
    // Identifichiamo la cella selezionata e resettiamo la precedente
    $('.aggiungi').removeClass('index');
    $(this).addClass('index');
    $('.form-presenza').removeClass('was-validated');

    // Faccio comparire il modal
    $('.modal').addClass('show fade');
    $('.modal-backdrop').addClass('show fade');
    $('#aggiungiPresenza').show();
    $('.modal-backdrop').show();

    // Estrazione dei dati dalla riga
    var id = $(this).parents('tr').attr('data-id');
    var data = $(this).parents('td').attr('data-data');
    var nome = $(this).parents('tr').attr('data-nome');
    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');

    // Inseriamo i dati identificatifi nella riga
    $(".nome").attr('data-id', id);
    $(".data").attr('data-data', data);
    
    // Mi creo la data con il formato desiderato
    var anno = data.substring(0, 4); 
    var mese = data.substring(5, 7); 
    var giorno = data.substring(8, 10);
    var dataFormato = giorno + '/' + mese + '/' + anno;
    
    // Popoliamo/resettiamo il model
    $("#finoA").val(dataFormato);
    $('.data').text(dataFormato);
    $('.nome').text(nome);
    $('.erroreFinoA').text('');
    $('.erroreTipo').text('');
    $('.erroreLuogo').text('');
    $('.erroreRimborso').text('');
    $('.erroreBonus').text('');

    // Chimata ajax per aggiornamento del modal 
    $.ajax({
        url: '/aggiorna',
        method: 'GET',
        dataType: 'json',
        data: {
            _token: CSRF_TOKEN,
            id: id,
            data: data,
        },
        'success': function(data){
 
            var presenza = data['presenze'][0];
            var collaboratore = data['collaboratore'][0];
            $('#importo').data('disabled', true);
            $('.intera').data('tariffa', collaboratore['rates_intera']);
            $('.mezza').data('tariffa', collaboratore['rates_mezza']);
            $('.estera').data('tariffa', collaboratore['rates_estera']);
            $('.formazione').data('tariffa', collaboratore['rates_formazione']);

            if (typeof presenza !== "undefined") {
                // Inseriamo le info della presenza
                $("#tipo").val(presenza['tipo']);
                $("#importo").val(presenza['importo']);
                $(".luogo").val(presenza['luogo']);
                $(".descrizione").val(presenza['descrizione']);
                $("#rimborso").val(presenza['rimborso']);
                $("#bonus").val(presenza['bonus']);
                $('#insFinoA').addClass('d-none');
                $('#form-elimina-presenza').removeClass('d-none');
                $('#id_presenza').val(presenza['id']);
                if (presenza['tipo'] == 5) { $('#importo').attr('disabled', false); }
            } else {
                // Reset delle info
                $('#insFinoA').removeClass('d-none');
                $('#form-elimina-presenza').addClass('d-none');
                $('.form-presenza').removeClass('was-validated');
                $("#tipo").val('');
                $("#importo").val('');
                $(".luogo").val('');
                $(".descrizione").val('');
                $("#rimborso").val('');
                $("#bonus").val(''); 
            }    

        },
        'error':function(){
            alert('errore!');
        }
    });
}); 

// Selezioniamo il tipo di presenza
$('#tipo').on('change', function(){
    $('#importo').attr('disabled', true);

    // Se l'importo é personalizzabile togliere disabled
    if($('#tipo').val() == 5){ 
        $('#importo').attr('disabled', false);
        $('#importo').val('');
    }
    else { 
        $('#importo').val($(this).find(':selected').data('tariffa')); 
    }
});

// Funzione per validare lato server il form
(function() {
    'use strict';
    window.addEventListener('load', function() {
    var forms = document.getElementsByClassName('form-presenza');
    var validation = Array.prototype.filter.call(forms, function(form) {
        form.addEventListener('submit', function(event) {

            // Se trova un dato mancante non prosegue
            event.preventDefault();
            event.stopPropagation();

            // Otteniamo i dati dalla riga salvati in precedenza e dal modal 
            var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
            var id = $(".nome").attr('data-id');
            var data = $(".data").attr('data-data');
            var tariffa = $("#tipo").val();
            var importo = $("#importo").val();
            var luogo = $('.luogo').val();
            var descrizione = $('.descrizione').val();
            var rimborso = $('#rimborso').val();
            var bonus = $('#bonus').val();
            var finoA = $('#finoA').val();

            // Mi creo la data con il formato desiderato
            var anno = finoA.substring(6, 10); 
            var mese = finoA.substring(3, 5); 
            var giorno = finoA.substring(0, 2);
            var dataFormato = mese + '/' + giorno + '/' + anno;

            var da = new Date(data);
            var fino = new Date(dataFormato);

            // Regex data dd/mm/yyyy valida
            var re = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;

            // Se i dati ricevuti non sono validi mandare un messaggio
            if (fino < da.setHours(0) || finoA.length === 0 || re.exec(finoA) == null)  {
                $('.erroreFinoA').text('Inserisci una data valida'); 
                return;
            } else { $('.erroreFinoA').text(''); }

            if (tariffa === null) { 
                $('.erroreTipo').text('Inserire tipo'); 
                return;
            } else { $('.erroreTipo').text(''); }

            if ($.trim(luogo) == '') { 
                $('.erroreLuogo').text('Inserire luogo'); 
                return;
            } else { $('.erroreLuogo').text(''); }
        
            if (form.checkValidity() === false) { 
                return;
            }

            // Chiamata ajax per il salvataggio della presenza
            $.ajax({
                url: '/salva',
                method: 'POST',
                dataType: 'json',
                data: {
                    _token: CSRF_TOKEN,
                    id: id,
                    data: data,
                    finoA: finoA,
                    tariffa: tariffa,
                    importo: importo,
                    luogo: luogo,
                    descrizione: descrizione,
                    rimborso: rimborso,
                    bonus: bonus,
                },
                'success': function(data){

                    // Mi ricavo il padre della prima data selezionata
                    var any = $('.index').parent('.info');

                    // Ciclo per tutte le presenze
                    for (let index = 0; index < data.length; index++) {

                        // Mi prendo la cella da colorare
                        any = any.children();

                        // Assegnazione colore in base al tipo
                        if (data[index].tipo == 1){ any.addClass('verde'); }
                        else if(data[index].tipo == 2){ any.addClass('arancione'); }
                        else if(data[index].tipo == 3){ any.addClass('giallo'); }
                        else if(data[index].tipo == 4){ any.addClass('grigio'); }
                        else if(data[index].tipo == 5){ any.addClass('celeste'); }

                        // Se presente il rimborso aggiungere '+ S' e/o bonus '+ B'
                        if (data[index].rimborso > 0 && data[index].bonus) { any.html('<i class="fas fa-check"></i> S B'); }
                        else if (data[index].rimborso > 0) {any.html('<i class="fas fa-check"></i> S'); }
                        else if (data[index].bonus > 0) {any.html('<i class="fas fa-check"></i> B'); }
                        else{any.html('<i class="fas fa-check"></i>');} 

                        // Mi prendo la riga successiva per il prossimo ciclo
                        any = any.parent('.info').next();
                    }
                    
                    $('#aggiungiPresenza').hide();
                    $('.modal-backdrop').hide();

                },
                'error':function(){
                    alert('errore!');
                }
            });      
            }, false);
    });
    }, false);
})();

// Index utente/
// Al click di cancella sostituire l'action del form con l'id selezionato
$('.table').on('click','.cancellaUtente', function(){
    var id = $(this).attr('data-id'); 
    $('#form-elimina').attr('action', ''+ window.location.href + '/'+ id +'');
    
    // Per eliminare l'utente con confirm javascript
    if (confirm('Sei sicuro di voler eliminare questo utente?')) { 
        event.preventDefault(); 
        $('#form-elimina').submit(); 
    }
});

// Index collaboratore
// Al click di cancella sostituire l'action del form con l'id selezionato
$('.table').on('click','.cancellaCollaboratore', function(){
    var id = $(this).attr('data-id'); 
    $('#form-elimina').attr('action', ''+ window.location.href + '/'+ id +'');
});

// Edit utente
// Checkbox per abilitare/disabilitare la modifica della password
$('.checkbox').on('click','.password', function(){
    $('.pass').prop('disabled', function(i, v) { return !v; });
    $('.conf-pass').prop('disabled', function(i, v) { return !v; });
});

// Reimpostare i filtri delle ricevute
$('.filtro').on('click','.reimposta', function(){
    $('.form-select').val('');
});




